import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { descryptValue, encryptStorage } from "src/app/auth/utils/storage";
import { CognitoService } from "src/app/shared/services/cognito.service";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
})
export class SidenavComponent implements OnInit {
  @ViewChild("sidebar", { static: false }) sidebar: ElementRef;
  @ViewChild("toggle", { static: false }) toggle: ElementRef;
  @ViewChild("search", { static: false }) search: ElementRef;
  @ViewChild("body", { static: false }) body: ElementRef;

  usuario: string = "";
  tipoPessoa: string = "";
  menuItems: any[] = [];

  constructor(
    private cognitoService: CognitoService,
    private renderer: Renderer2,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.usuario = encryptStorage.getItem("@user", false);
    this.tipoPessoa = encryptStorage.getItem("@tipoPessoa", false);
    this.menuItems = this.createMenuItems(
      "ENTIDADE",
      encryptStorage.getItem("@documentoIdentificador")
    );
  }

  removeClose() {
    const active = this.sidebar.nativeElement.classList.contains("close");
    this.renderer[active ? "removeClass" : "addClass"](
      this.sidebar.nativeElement,
      "close"
    );

    this.renderer[active ? "addClass" : "removeClass"](
      this.body.nativeElement,
      "isOpen"
    );
  }

  resetStorage() {
    this.cognitoService.logout();
  }

  goToDetail(item) {
    this.router.navigateByUrl(item);
  }

  private createMenuItems(
    perfilUsuario: string,
    documentoIdentificador: string
  ) {
    let userActions: any[] = [];

    switch (perfilUsuario) {
      case "ENTIDADE": {
        userActions = [
          {
            urlPath: "/spg/home-ordinaria",
            nameItem: "Garantia Ordinária",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/home-dpge",
            nameItem: "Garantia DPGE (Especial)",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/perfil-investidor",
            nameItem: "Meu Perfil",
            icon: "fas fa-file-invoice-dollar icon",
          },
        ];
        break;
      }
      case "InvestidorFI".toUpperCase(): {
        userActions = [
          {
            urlPath: "/spg/home-ordinaria",
            nameItem: "Garantia Ordinária",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/home-dpge",
            nameItem: "Garantia DPGE (Especial)",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/perfil-investidor",
            nameItem: "Meu Perfil",
            icon: "fas fa-file-invoice-dollar icon",
          },
        ];
        break;
      }
      case "INVESTIDOR": {
        if (documentoIdentificador.length > 13) {
          userActions = [
            {
              urlPath: "/spg/home-ordinaria",
              nameItem: "Garantia Ordinária",
              icon: "fas fa-home icon",
            },
            {
              urlPath: "/spg/home-dpge",
              nameItem: "Garantia DPGE (Especial)",
              icon: "fas fa-home icon",
            },
            {
              urlPath: "/spg/perfil-investidor",
              nameItem: "Meu Perfil",
              icon: "fas fa-file-invoice-dollar icon",
            },
          ];
        } else {
          userActions = [
            {
              urlPath: "/spg/home-dpge",
              nameItem: "Garantia DPGE (Especial)",
              icon: "fas fa-home icon",
            },
            {
              urlPath: "/spg/perfil-investidor",
              nameItem: "Meu Perfil",
              icon: "fas fa-file-invoice-dollar icon",
            },
          ];
        }
        break;
      }

      default: {
        userActions = ["NO_ACCESS"];
        break;
      }
    }

    return userActions;
  }
}
